// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g6Ym","colBig":"styles_colBig__2y1-P","colSmall":"styles_colSmall__1i9sN"};